import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Actor {
  id: string;
  name: string;
  image: string;
}

// Larger set of featured models for this variant
const featuredModels: Actor[] = [
  { id: "baddie1", name: "Aria", image: "/baddies/baddie1.jpg" },
  { id: "baddie2", name: "Luna", image: "/baddies/baddie2.jpg" },
  { id: "baddie3", name: "Nova", image: "/baddies/baddie3.jpg" },
  { id: "baddie4", name: "Sophia", image: "/baddies/baddie4.jpg" },
  { id: "baddie5", name: "Isabella", image: "/baddies/baddie5.jpg" },
  { id: "baddie6", name: "Mia", image: "/baddies/baddie6.jpg" },
  { id: "baddie7", name: "Charlotte", image: "/baddies/baddie7.jpg" },
  { id: "baddie8", name: "Amelia", image: "/baddies/baddie8.jpg" },
  { id: "baddie9", name: "Harper", image: "/baddies/baddie9.jpg" },
  { id: "baddie10", name: "Evelyn", image: "/baddies/baddie10.jpg" },
  { id: "baddie11", name: "Abigail", image: "/baddies/baddie11.jpg" },
  { id: "baddie12", name: "Emily", image: "/baddies/baddie12.jpg" },
  { id: "baddie13", name: "Elizabeth", image: "/baddies/baddie13.jpg" },
  { id: "baddie14", name: "Mila", image: "/baddies/baddie14.jpg" },
  { id: "baddie15", name: "Ella", image: "/baddies/baddie15.jpg" },
  { id: "baddie16", name: "Avery", image: "/baddies/baddie16.jpg" },
  { id: "baddie17", name: "Scarlett", image: "/baddies/baddie17.jpg" },
  { id: "baddie18", name: "Madison", image: "/baddies/baddie18.jpg" },
  { id: "baddie19", name: "Victoria", image: "/baddies/baddie19.jpg" },
  { id: "baddie20", name: "Jasmine", image: "/baddies/baddie20.jpg" },
  { id: "baddie21", name: "Zoe", image: "/baddies/baddie21.jpg" },
  { id: "baddie22", name: "Lily", image: "/baddies/baddie22.jpg" },
  { id: "baddie23", name: "Grace", image: "/baddies/baddie23.jpg" },
  { id: "baddie24", name: "Chloe", image: "/baddies/baddie24.jpg" },
];

const NoFilter2: React.FC = () => {
  const navigate = useNavigate();

  // Track page view on mount (disabled for showcase)
  useEffect(() => {
    // Analytics removed for showcase site
  }, []);

  const handleCharacterClick = (character: Actor) => {
    // Analytics removed for showcase site

    // Navigate to image-to-video with wan2.2-nofilter model and character image pre-loaded
    navigate("/video/i2v", {
      state: {
        referenceImage: character.image,
        selectedModel: "wan2.2-nofilter",
        noFilterMode: true,
      },
    });
  };

  const handleCreateClick = () => {
    // Analytics removed for showcase site

    // Navigate to image-to-video with wan2.2-nofilter model preselected
    navigate("/video/i2v", {
      state: {
        selectedModel: "wan2.2-nofilter",
        noFilterMode: true,
      },
    });
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Video Hero Section - Leads with proof */}
      <div className="relative px-4 py-8 md:py-16">
        <div className="max-w-6xl mx-auto">
          {/* Headline */}
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-4 animate-fade-in">
              See It In Action 🌶️
            </h1>
            <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
              Watch real videos created in under 60 seconds
            </p>
          </div>

          {/* Large Featured Video Grid - 6 videos in 1:1 ratio */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/30 hover:border-white/60 transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example14.mp4"
                poster="/baddies/baddie8.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-bold text-sm drop-shadow-lg">
                  Amelia's Seduction
                </h3>
              </div>
            </div>

            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example15.mp4"
                poster="/baddies/baddie9.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-white font-semibold text-sm drop-shadow-lg">
                  Harper's Temptation
                </h3>
              </div>
            </div>

            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example_4.mp4"
                poster="/baddies/baddie12.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-white font-semibold text-sm drop-shadow-lg">
                  Emily Wilding Out
                </h3>
              </div>
            </div>

            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example_8.mp4"
                poster="/baddies/baddie6.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-white font-semibold text-sm drop-shadow-lg">
                  Mia Showing Off
                </h3>
              </div>
            </div>

            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example16.mp4"
                poster="/baddies/baddie15.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-white font-semibold text-sm drop-shadow-lg">
                  Ella's Desire
                </h3>
              </div>
            </div>

            <div className="group relative aspect-square rounded-2xl overflow-hidden border-2 border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example_3.mp4"
                poster="/baddies/baddie10.jpg"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h3 className="text-white font-semibold text-sm drop-shadow-lg">
                  Evelyn's Happy Place
                </h3>
              </div>
            </div>
          </div>

          {/* Main Value Prop */}
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 text-white">
              Pick a Model. Type Anything. Get Your Video.
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              The fastest way to create unfiltered AI videos. No experience needed.
            </p>
            <button
              onClick={handleCreateClick}
              className="inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-xl font-bold px-10 py-4 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_rgba(255,255,255,0.5)] hover:scale-105"
            >
              Create Your First Video
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Models Section - Grid Heavy */}
      <div className="relative px-4 py-12 bg-gradient-to-b from-black via-gray-900 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Choose From 300+ Professional Models
            </h3>
            <p className="text-gray-400">Click any model to start creating instantly</p>
          </div>

          {/* Dense Grid of Models */}
          <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3 mb-8">
            {featuredModels.map((model, index) => (
              <button
                key={model.id}
                onClick={() => handleCharacterClick(model)}
                className="group relative aspect-square rounded-xl overflow-hidden border border-white/20 hover:border-white/60 transition-all duration-300 hover:scale-110 hover:z-10 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)]"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <img
                  src={model.image}
                  alt={model.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                <div className="absolute bottom-0 left-0 right-0 p-1.5 transform translate-y-full group-hover:translate-y-0 transition-transform duration-200">
                  <p className="text-white font-semibold text-xs text-center drop-shadow-lg">
                    {model.name}
                  </p>
                </div>
              </button>
            ))}
          </div>

          {/* CTA Below Models */}
          <div className="text-center">
            <p className="text-gray-400 mb-4">Or upload your own image</p>
            <button
              onClick={handleCreateClick}
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 text-white font-semibold px-8 py-3 rounded-xl transition-all duration-300 hover:scale-105"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Upload Your Own
            </button>
          </div>
        </div>
      </div>

      {/* How It Works - Step by Step */}
      <div className="relative px-4 py-16 bg-black">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
            3 Simple Steps
          </h3>
          
          <div className="space-y-8">
            {/* Step 1 */}
            <div className="flex gap-6 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-white text-black rounded-full flex items-center justify-center text-xl font-bold">
                1
              </div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-white mb-2">Pick a Model or Upload Your Own</h4>
                <p className="text-gray-400">Choose from 300+ pre-made models or upload any image you want.</p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex gap-6 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-white text-black rounded-full flex items-center justify-center text-xl font-bold">
                2
              </div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-white mb-2">Describe What You Want to See</h4>
                <p className="text-gray-400">Type anything - the AI brings your imagination to life.</p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex gap-6 items-start">
              <div className="flex-shrink-0 w-12 h-12 bg-white text-black rounded-full flex items-center justify-center text-xl font-bold">
                3
              </div>
              <div className="flex-1">
                <h4 className="text-xl font-bold text-white mb-2">Get Your Video in 60 Seconds</h4>
                <p className="text-gray-400">Download and share your creation. No watermarks.</p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <button
              onClick={handleCreateClick}
              className="inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-xl font-bold px-10 py-4 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_rgba(255,255,255,0.5)] hover:scale-105"
            >
              Start Creating Now
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* More Models Showcase */}
      <div className="relative px-4 py-16 bg-gradient-to-b from-black via-gray-900 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Explore All Models
            </h3>
            <p className="text-gray-400 text-lg">Every style, every type. Find your perfect match.</p>
          </div>

          {/* Horizontal Scrolling Preview */}
          <div className="relative mb-8">
            <div className="flex gap-3 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory">
              {featuredModels.slice(0, 12).map((model) => (
                <button
                  key={model.id}
                  onClick={() => handleCharacterClick(model)}
                  className="group relative flex-shrink-0 w-32 md:w-40 aspect-[3/4] rounded-xl overflow-hidden border-2 border-white/20 hover:border-white/50 transition-all duration-300 hover:scale-105 snap-start"
                >
                  <img
                    src={model.image}
                    alt={model.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-2">
                    <p className="text-white font-bold text-sm text-center drop-shadow-lg">
                      {model.name}
                    </p>
                  </div>
                  {/* Quick action indicator */}
                  <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="bg-white/90 rounded-full p-1">
                      <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div className="text-center">
            <button
              onClick={handleCreateClick}
              className="inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-lg font-bold px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Browse All 300+ Models
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Final Push Section */}
      <div className="relative px-4 py-20 bg-black">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-5xl font-black text-white">
            Ready to Create Something Naughty?
          </h2>
          <p className="text-xl text-gray-300">
            Join thousands of creators making viral content
          </p>
          <button
            onClick={handleCreateClick}
            className="inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-xl font-bold px-12 py-5 rounded-full transition-all duration-300 shadow-[0_0_40px_rgba(255,255,255,0.3)] hover:shadow-[0_0_60px_rgba(255,255,255,0.5)] hover:scale-110"
          >
            Get Started
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="relative px-4 py-8 bg-black border-t border-white/10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-500 text-sm leading-relaxed">
            The "No Filter" mode is designed for creative and entertainment purposes. 
            Users are responsible for ensuring their content complies with platform 
            guidelines and applicable laws. PixelMaker does not endorse or take 
            responsibility for user-generated content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoFilter2;

